module.exports = __webpack_public_path__ + "static/media/country_lv.3f54f0ce.webp";